import { Controller } from 'react-hook-form';
import { DatePicker, Message } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import moment from 'moment';
import { prop } from 'ramda';
import { useEffect } from 'react';

const isValidDate = (dateString) => {
  if (!dateString) return false;
  const date = moment(dateString, 'DD/MM/YYYY', true);
  return date.isValid();
};

const ControlledDatePicker = ({
  name,
  form,
  rules,
  label,
  tooltip = '',
  containerClassName = '',
  className = '',
  children,
  triggerOnChange = false,
  withIndicator = true,
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const $label = prop('required', rules) ? `${label} *` : label;

  const isDateInvalid = (date) => {
    if (!date) return !!prop('required', rules); // Champ vide : erreur seulement si required

    if (!isValidDate(date)) return true; // Format invalide
    const parsedDate = moment(date, 'DD/MM/YYYY', true);
    if (extraProps.minDate && parsedDate.isBefore(extraProps.minDate, 'day')) return true;

    if (extraProps.maxDate && parsedDate.isAfter(extraProps.maxDate, 'day')) return true;

    return false;
  };

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => {
          const value = props.field.value;
          const hasError = isDateInvalid(props.field.value);

          useEffect(() => {
            form.trigger(name);
            return () => {
              form.clearErrors(name);
            };
          }, [hasError]);

          return (
            <div className={`flex items-center w-full ${className}`}>
              <DatePicker
                tooltip={tooltip}
                label={$label}
                withIndicator={withIndicator}
                error={hasError}
                {...props}
                {...props.field}
                {...extraProps}
                value={value}
                selected={isValidDate(value) ? moment(value, 'DD/MM/YYYY').toDate() : null}
                onChange={async (date) => {
                  if (date) {
                    props.field.onChange(moment(date).format('DD/MM/YYYY'));
                  } else {
                    props.field.onChange(date);
                  }
                  if (triggerOnChange) await form.trigger();
                }}
                onChangeRaw={(e) => {
                  props.field.onChange(e.target.value);
                }}
                locale="fr"
              />
              {children}
            </div>
          );
        }}
      />
      <Message variant="error" label={getErrorMessage(form.formState.errors, name)}/>
    </div>
  );
};

export default ControlledDatePicker;
